import config from '@/config'
import AppState from '@/states/app'
import { requests } from './BaseService'


export interface ICreateSmsTemplateOptions {
  locationId: string
  name: string
  text: string
  updatedBy?: string
}

export interface ISms {
  to: string
  message: string
}

export enum TestMessageTypes {
  SMS = 'sms',
  EMAIL = 'email',
  WEBHOOK = 'webhook'
}

export interface ITestMessageDto {
  type: TestMessageTypes
  userId: string
  locationId: string
  url?: string
  email?: string
  phone?: string
  subject?: string
  message: string
  attachments?: string[]
  urlAttachments?: string[]
  fromAddress?: string
  templateId?: string
  rssFeedURL?: string
  fromNumber?: string
}

export default class SmsService {
  sms: ISms

  constructor(sms) {
    this.sms = sms
  }

  async sendTestSms() {
    try {
      const payload: ITestMessageDto = {
        type: TestMessageTypes.SMS,
        userId: AppState.user?.id || '',
        locationId: AppState.locationId || '',
        phone: this.sms.to,
        message: this.sms.message,
        attachments: []
      }
      await requests().post(`${config.restApiUrl}/conversations/messages/test`, payload)
    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

export const SmsBuilderService = {
  createSmsTemplate: (options: ICreateSmsTemplateOptions) =>
    requests().post(
      `${config.restApiUrl}/locations/${AppState.locationId}/templates`,
      {
        type: 'sms',
        name: options.name,
        template: {
          body: options.text,
        },
      }
    ),
}
